import {Component, ElementRef, EventEmitter,
  Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {PedidoLoja} from "../../objeto/PedidoLoja";
import {DadosCartao} from "../../objeto/DadosCartao";
import {ICartaoCreditoGateway} from "../../objeto/ICartaoCreditoGateway";
import {FormUtils} from "../../objeto/FormUtils";
import {HttpClient} from "@angular/common/http";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";

declare const window: any;

@Component({
  selector: 'app-cad-cartao-pagarme',
  templateUrl: './cad-cartao-pagarme.component.html',
  styleUrls: ['./cad-cartao-pagarme.component.scss']
})
export class CadCartaoPagarmeComponent implements OnInit, ICartaoCreditoGateway {
  @ViewChild('frm', {static: true}) frm: NgForm;
  @ViewChild('frm', {read: ElementRef}) public frmElement: ElementRef;
  @Input() parcelamento: any;
  @Input() gateway: string;
  @Input() pedido: PedidoLoja;
  // tslint:disable-next-line:no-output-on-prefixsn
  @Output() onCriou = new EventEmitter();
  empresa: any;
  processando: any;
  mensagemSucesso: any;
  mensagemErro: any;
  cartao: any = new DadosCartao();
  bandeira: any = null;
  paymentMethod: any;
  parcelasValores = [];
  parcela: any;
  publicKey: string;
  carregando = true;
  carregando3ds = false;
  carregandoScript3ds = false;
  script3dsPronto = false;
  ambiente3ds = 'dev';
  promessaScript3ds: Promise<void>;
  autenticar3ds = false;
  cartaoTeste: any;
  cartoesSalvos: any[] = [];
  cartaoSalvoSelecionado: any;
  exigirCvvCartaoSalvo = false;
    constructor( private autorizacaoService: AutorizacaoLojaService,
                 protected http: HttpClient ) {
      this.cartaoTeste = {
        "number": '4111111111111111',
        "holder_name": "Comprador Teste",
        "exp_month":  "10",
        "exp_year":  (new Date().getFullYear() + 2).toString().substr(2),
        "cvv": "123"
      }
  }

  ngOnInit(): void {
    this.http.get(String(`/api/empresas/me/${this.gateway}/pk`)).toPromise().then((resp: any) => {
       if(resp.publicKey){
         this.publicKey = resp.publicKey;
         this.tokenizeCartao(this.cartaoTeste).then((res) => {
           this.carregando = false;
         }).catch((err) => {
           console.error(err)
           this.mensagemErro = 'Não será possível validar o cartão, informe a loja para habilitar o dominio de compra';
           this.carregando = false;
         })
         this.setDadosUsuarioNoCartao();
       } else {
         this.mensagemErro =  resp.erro ?  resp.erro : 'Não foi possivel obter token da conta';
         this.carregando = false;
       }
    }).catch((erro) => {
      this.carregando = false;
      this.mensagemErro = 'Falha ou obter token'
    })

    this.carregueConfiguracao3ds().catch((erro) => {
      console.error(erro);
    });
  }

  setDadosUsuarioNoCartao(){
    let usuario = this.autorizacaoService.getUsuario();
    if(!usuario) usuario = this.pedido?.contato;

    if(usuario && usuario.cpf) this.cartao.cpf = usuario.cpf
    if(usuario && usuario.email) this.cartao.email = usuario.email
  }

  setParcelamento(numeroParcelasFixas: number){
    if(numeroParcelasFixas){
      let total;

      if((this.pedido as any).cliente) { // pedido server
        total  = this.pedido.total;
      } else {
        total = this.pedido.obtenhaValorAhPagar();
      }

      for(let i = 1; i <= numeroParcelasFixas; i++){
        let parcela: any =  Number((total / i).toFixed(2));

        parcela = parcela.toFixed(2).replace('.', ',')

        this.parcelasValores.push({id: i, descricao: String(`${i}x de R$ ${parcela} sem juros`)})
      }
    }

    if(this.parcelasValores.length === 1)
      this.parcela = this.parcelasValores[0]

  }

  tokenizeCartao(card: any){
    let dadosCartao: any = {
      type: "card",
      card: card
    }

    return new Promise( (resolve, reject) => {
      this.http.post('https://api.pagar.me/core/v5/tokens?appId=' + this.publicKey, dadosCartao)
        .toPromise().then( (res: any) => {
        console.log(res);
        resolve(res);
      }).catch((fail: any) => {
        let erro = 'Cartão inválido';
        if(fail.status === 0)
          erro = 'Não foi possível criar token do cartão, informe a loja para habilitar o dominio de compra'

        if(fail.error && fail.error.errors && fail.error.errors['request.card'])
          erro += ":" +   fail.error.errors['request.card'][0]

        reject(erro)
      } )
    })

  }

  crieTokenCartao(enderecoCobranca: any): Promise<DadosCartao> {
    return new Promise( (resolve, reject) => {
      if(this.cartaoSalvoSelecionado){
        this.cartao.cartaoSalvoId = this.cartaoSalvoSelecionado.cartaoSalvoId || this.cartaoSalvoSelecionado.id;
        this.cartao.ultimosNumeros = this.cartaoSalvoSelecionado.ultimosNumeros;
        this.cartao.bandeira = this.cartaoSalvoSelecionado.bandeira;
        this.cartao.descricaoPagamento = this.cartaoSalvoSelecionado.descricaoPagamento;
        this.cartao.cvv = this.cartaoSalvoSelecionado.cvvCartaoSalvo || '';
        return resolve(this.cartao);
      }

      if(this.parcela)
        this.cartao.parcela =  this.parcela.id;
      delete this.cartao.autenticacao3ds;

      let dadosCartao: any = {
          "number": this.cartao.numero,
          "holder_name": this.cartao.nome,
          "exp_month":  (this.cartao.validade.getMonth() + 1),
          "exp_year":  this.cartao.validade.getFullYear().toString().substr(2),
          "cvv": this.cartao.cvv
      }

      this.tokenizeCartao(dadosCartao).then((res: any) => {
        let tokenize: any = { card: dadosCartao};

        tokenize.publicKey =  this.publicKey;
        tokenize.dataExpiracao =  new Date().setSeconds(new Date().getSeconds() + 55); //60s

        this.autentique3ds(dadosCartao, enderecoCobranca).then((idAutenticacao: string) => {
          debugger
          if(idAutenticacao)
            this.cartao.autenticacao3ds = idAutenticacao;

          this.cartao.setRetornoTokenCartaoPagarme(res, tokenize);
          resolve(this.cartao);
        }).catch((erro3ds: any) => {
          reject(erro3ds);
        })
      }).catch((err: any) => {
        reject(err)
      })
    })
  }

  private async carregueConfiguracao3ds(){
    if(this.script3dsPronto) return;

    if(this.promessaScript3ds)   return this.promessaScript3ds;

    this.promessaScript3ds = new Promise<void>(async (resolve, reject) => {
      const appInfo: any = await this.http.get('/pagarme/app/info').toPromise().catch(() => null);
      if(appInfo.autenticar3ds){
        this.autenticar3ds = true;
        if(appInfo && appInfo.env)
          this.ambiente3ds = appInfo.env;

        this.carregueScript3ds().then(() => resolve()).catch((erro) => reject(erro));
      }

    });

    return this.promessaScript3ds.finally(() => {
      if(!this.script3dsPronto)
        this.promessaScript3ds = null;
    });
  }

  private carregueScript3ds(){
    return new Promise<void>((resolve, reject) => {
      if(this.script3dsPronto || (window.TDS && typeof window.TDS.init === 'function')){
        this.script3dsPronto = true;
        return resolve();
      }

      const urlScript = this.ambiente3ds === 'production' ?
        'https://3ds-nx-js.stone.com.br/live/v2/3ds2.min.js' :
        'https://3ds-nx-js.stone.com.br/test/v2/3ds2.min.js';

      const scriptExistente = document.querySelector(`script[src="${urlScript}"]`) as HTMLScriptElement;
      if(scriptExistente){
        scriptExistente.addEventListener('load', () => {
          this.script3dsPronto = true;
          resolve();
        });
        scriptExistente.addEventListener('error', () => {
          reject('Não foi possível carregar a biblioteca de autenticação 3DS');
        });

        return;
      }

      this.carregandoScript3ds = true;
      const script = document.createElement('script');
      script.src = urlScript;
      script.async = true;
      script.onload = () => {
        this.script3dsPronto = true;
        this.carregandoScript3ds = false;
        resolve();
      };
      script.onerror = () => {
        this.carregandoScript3ds = false;
        reject('Não foi possível carregar a biblioteca de autenticação 3DS');
      };
      document.body.appendChild(script);
    });
  }

  private async obtenhaToken3ds(): Promise<string>{
    const resposta: any = await this.http.get('/pagarme/3ds/token').toPromise().catch((erro) => {
      throw erro;
    });

    if(resposta && resposta.sucesso && resposta.data && resposta.data.token)
      return resposta.data.token;

    if(resposta && resposta.token)
      return resposta.token;

    throw new Error((resposta && resposta.erro) ? resposta.erro : 'Não foi possível obter token 3DS');
  }

  private monteOrder3ds(dadosCartao: any, enderecoCobranca: any){
    const usuario = this.autorizacaoService.getUsuario() || this.pedido?.contato || {};
    const telefone = ((usuario.telefone || this.pedido?.contato?.telefone || '') + '').replace(/\D/g, '');
    const areaCode = telefone.length >= 2 ? telefone.substr(0, 2) : '11';
    const number = telefone.length > 2 ? telefone.substr(2) : '999999999';
    const totalPedido = (this.pedido as any).cliente ? this.pedido.total : this.pedido.obtenhaValorAhPagar();
    const totalCentavos = Math.round(Number(totalPedido || 0) * 100);

    if(!enderecoCobranca || !enderecoCobranca.cidade || !enderecoCobranca.cidade.estado){
      throw new Error('Endereço de cobrança é obrigatório para autenticação 3DS');
    }

    const billingAddress = {
      country: 'BR',
      state: enderecoCobranca.cidade.estado.sigla,
      city: enderecoCobranca.cidade.nome,
      zip_code: String(enderecoCobranca.cep || '').replace(/\D/g, ''),
      line_1: String(`${enderecoCobranca.numero || 'SN'}, ${enderecoCobranca.logradouro || ''}, ${enderecoCobranca.bairro || ''}`).trim(),
      line_2: String(enderecoCobranca.complemento || '')
    };

    return {
      customer: {
        name: dadosCartao.holder_name || this.cartao.nome || usuario.nome || 'Cliente',
        email: this.cartao.email || usuario.email || 'email@nao-informado.com',
        code: (usuario.id || this.pedido?.contato?.id || '').toString(),
        document: String(this.cartao.cpf || usuario.cpf || '').replace(/\D/g, ''),
        phones: {
          mobile_phone: {
            country_code: '55',
            area_code: areaCode,
            number: number
          }
        }
      },
      items: [
        {
          description: String(`Pedido #${this.pedido?.codigo || ''}`),
          code: String(this.pedido?.codigo || 'pedido')
        }
      ],
      shipping: {
        recipient_name: this.pedido?.contato?.nome || usuario.nome || 'Cliente',
        address: billingAddress
      },
      payments: [
        {
          payment_method: 'credit_card',
          amount: totalCentavos,
          credit_card: {
            card: {
              number: String(dadosCartao.number || '').replace(/\D/g, ''),
              holder_name: dadosCartao.holder_name,
              exp_month: Number(dadosCartao.exp_month),
              exp_year: Number(`20${dadosCartao.exp_year}`),
              billing_address: billingAddress
            }
          }
        }
      ],
      requestor_url: window.location ? window.location.origin : null
    };
  }

  private async autentique3ds(dadosCartao: any, enderecoCobranca: any): Promise<string>{
    if(!this.autenticar3ds) return Promise.resolve(null);

    this.carregando3ds = true;
    await this.carregueConfiguracao3ds();

    if(!window.TDS || typeof window.TDS.init !== 'function'){
      this.carregando3ds = false;
      throw new Error('Biblioteca de autenticação 3DS não disponível');
    }

    const tdsMethodContainer = document.getElementById('tdsMethodContainer');
    const challengeContainer = document.getElementById('challengeContainer');

    if(!tdsMethodContainer || !challengeContainer){
      this.carregando3ds = false;
      throw new Error('Containers do 3DS não encontrados na página');
    }

    try{
      const token3ds = await this.obtenhaToken3ds();
      const orderData: any = this.monteOrder3ds(dadosCartao, enderecoCobranca);

      const response: any[] = await window.TDS.init({
        token: token3ds,
        tds_method_container_element: tdsMethodContainer,
        challenge_container_element: challengeContainer,
        use_default_challenge_iframe_style: true,
        challenge_window_size: '03'
      }, orderData);

      const autenticacao = response && response.length ? response[0] : null;
      if(!autenticacao || !autenticacao.tds_server_trans_id){
        throw new Error('Não foi possível concluir a autenticação 3DS');
      }

      const status = String(autenticacao.trans_status || '').toUpperCase();
      const statusAceitos = ['Y', 'A', 'C'];
      if(autenticacao.challenge_canceled || (status && statusAceitos.indexOf(status) < 0)){
        throw new Error(`Autenticação 3DS não aprovada (status ${status || 'desconhecido'})`);
      }

      return autenticacao.tds_server_trans_id;
    } catch (erro: any){
      if(window.TDS && window.TDS.TDSError && erro instanceof window.TDS.TDSError){
        const detalhe = typeof erro.message === 'string' ? erro.message : 'Falha ao autenticar o cartão no 3DS';
        throw new Error(detalhe);
      }

      throw erro;
    } finally {
      this.carregando3ds = false;
    }
  }

  ehValido(): any {
    (this.frm as { submitted: boolean }).submitted = true;

    if(this.cartaoSalvoSelecionado){
      if(this.exigirCvvCartaoSalvo && (!this.cartaoSalvoSelecionado.cvvCartaoSalvo ||
        this.cartaoSalvoSelecionado.cvvCartaoSalvo.trim().length < 3)){
        return {
          valido: false,
          controle: this.frm.controls['cvvCartaoSalvo']
        }
      }

      return {
        valido: true,
        controle: null
      };
    }

    const ctrlInvalido = FormUtils.obtenhaControleInvalido(this.frm, this.frmElement);

    if (ctrlInvalido) {
      return {
        valido: false,
        controle: ctrlInvalido
      }
    }

    return {
      valido: this.frm.valid,
      controle: null
    };
  }

  exibaCartao(dadosCartao: DadosCartao) {
    this.cartao = new DadosCartao();
    this.exigirCvvCartaoSalvo = false;
    this.cartaoSalvoSelecionado = null;

    if(dadosCartao){
      Object.assign(this.cartao, dadosCartao);
      this.exigirCvvCartaoSalvo = (dadosCartao as any).exigirCvvCartaoSalvo === true;
    }

    if(this.cartao && this.cartao.cartaoSalvoId  ){
      this.carregueCartoesSalvos().then( () => {
        const cartaoSalvo = this.cartoesSalvos.find((item: any) => item.cartaoSalvoId === this.cartao.cartaoSalvoId);
        if(cartaoSalvo){
          this.cartaoSalvoSelecionado = cartaoSalvo;
        }
      })

    } else {
      this.setDadosUsuarioNoCartao();
    }

    if((dadosCartao as any) && (dadosCartao as any).exigirCvvCartaoSalvo)
      this.exigirCvvCartaoSalvo = true;
  }

   carregueCartoesSalvos(){
      return new Promise( (resolve: any) => {
        let cartoesSalvos = [] // buscar do sever
        this.cartoesSalvos = cartoesSalvos.map(c => {
          let d = new DadosCartao();
          Object.assign(d, c);
          d.cartaoSalvoId = c.id;
          return d;
        });
        resolve()
      })
  }

  alterouNumeroCartao() {

  }

  fecheMensagemErro(){
    delete this.mensagemErro;
  }

  escolherNovoCartao(){
    this.cartaoSalvoSelecionado = null;
    this.exigirCvvCartaoSalvo = false;
    this.exibaCartao(null);
  }

  escolherCartaoSalvo(cartao: any){
    if(!cartao) return this.escolherNovoCartao();

    this.cartaoSalvoSelecionado = cartao;
    this.exibaCartao(cartao);
  }
}
